module.exports = __webpack_public_path__ + "img/xls.65b63515.svg";